<template>
    <div class="animate-pulse">
        <!-- Filter section skeleton (e.g. Merk) -->
        <div v-for="i in 3" :key="i" class="mb-6 pb-4">
            <div class="border-green-550 mb-6 flex w-full items-center justify-between border-b-2 px-4 pb-5">
                <div class="h-[19px] w-16 rounded bg-green-300"></div>
                <div class="size-3 rounded bg-green-300"></div>
            </div>
            <div class="space-y-7 pr-6 pl-4">
                <div v-for="j in 4" :key="j" class="flex items-center gap-x-1.5">
                    <div class="size-4 shrink-0 rounded border-2 border-green-300"></div>
                    <div class="h-4 rounded bg-green-300" :class="j % 2 === 0 ? 'w-2/3' : 'w-1/2'"></div>
                </div>
            </div>
        </div>

        <!-- Price filter skeleton -->
        <div class="pb-4">
            <div class="border-green-550 mb-6 flex w-full items-center justify-between border-b-2 px-4 pb-5">
                <div class="h-[19px] w-12 rounded bg-green-300"></div>
                <div class="size-3 rounded bg-green-300"></div>
            </div>
            <div class="px-4">
                <div class="mb-1 flex items-center gap-2">
                    <div class="flex-1">
                        <div class="mb-1 h-3 w-8 rounded bg-green-300"></div>
                        <div class="h-[52px] w-full rounded bg-green-200"></div>
                    </div>
                    <div class="mt-4 w-[14px] border-b-2 border-green-300"></div>
                    <div class="flex-1">
                        <div class="mb-1 h-3 w-6 rounded bg-green-300"></div>
                        <div class="h-[52px] w-full rounded bg-green-200"></div>
                    </div>
                </div>
                <div class="mt-5 flex items-center px-1">
                    <div class="h-1.5 w-full rounded-md bg-gray-200"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts"></script>
